var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Excel_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Excel_svg__b)",
    d: "M6.252 3.503H22v18.188H6.252z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.308 3.604H7.823a.786.786 0 0 0-.786.786v15.092c0 .434.352.785.786.785h12.485a.786.786 0 0 0 .786-.785V4.39a.786.786 0 0 0-.786-.786Z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Excel_svg__c)",
    d: "M6.621 3.429h14.861V20.73H6.621z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.306 3.604H7.821a.786.786 0 0 0-.786.786v15.092c0 .434.352.785.786.785h12.485a.786.786 0 0 0 .786-.785V4.39a.786.786 0 0 0-.786-.786Z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.324 3.614h-6.47a.767.767 0 0 0-.776.777v3.382h7.283l-.037-4.159Z",
    fill: "#21A366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.309 3.614H14.32v4.16h6.774V4.38a.777.777 0 0 0-.785-.767Z",
    fill: "#33C481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.085 11.932H14.32V16.1h6.765v-4.168Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.322 16.1v-4.168H7.039v7.55a.767.767 0 0 0 .776.777H20.31a.778.778 0 0 0 .786-.777V16.1h-6.774Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.33 7.764H7.04v4.168h7.29V7.764Z",
    fill: "#107C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.085 7.764H14.32v4.168h6.765V7.764Z",
    fill: "#21A366"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Excel_svg__d)",
    d: "M1.096 6.11h13.086v13.086H1.096z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.457 7.247h-7.8a.786.786 0 0 0-.786.785v7.8c0 .434.352.786.786.786h7.8a.786.786 0 0 0 .785-.786v-7.8a.786.786 0 0 0-.785-.785Z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Excel_svg__e)",
    d: "M2.629 6.979h9.981v9.981H2.629z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.457 7.247h-7.8a.786.786 0 0 0-.786.786v7.8c0 .434.352.785.786.785h7.8a.786.786 0 0 0 .785-.785v-7.8a.786.786 0 0 0-.785-.786Z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.457 7.246h-7.8a.786.786 0 0 0-.786.786v7.8c0 .433.352.785.786.785h7.8a.786.786 0 0 0 .785-.785v-7.8a.786.786 0 0 0-.785-.786Z",
    fill: "#107C41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m5.293 14.473 1.636-2.541-1.497-2.533h1.21l.814 1.608c.061.113.114.23.157.352.05-.124.11-.244.175-.36l.924-1.609h1.11l-1.58 2.542 1.58 2.56H8.637l-.924-1.784a1.08 1.08 0 0 1-.12-.231 1.6 1.6 0 0 1-.11.23l-.98 1.785-1.211-.019Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5,
    d: "M11.457 7.246h-7.8a.786.786 0 0 0-.786.786v7.8c0 .433.352.785.786.785h7.8a.786.786 0 0 0 .785-.785v-7.8a.786.786 0 0 0-.785-.786Z",
    fill: "url(#Excel_svg__f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "Excel_svg__b",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Excel_svg__g",
    transform: "scale(.01389 .01205)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Excel_svg__c",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Excel_svg__h",
    transform: "scale(.0147 .01266)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Excel_svg__d",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Excel_svg__i",
    transform: "scale(.01667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Excel_svg__e",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Excel_svg__j",
    transform: "scale(.02174)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Excel_svg__g",
    width: 72,
    height: 83,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB4ElEQVR4Xu3cwWrUUABG4XPbUMGNCnYhOM/hpjtfXRDtYziioFRcNqZeF/dmJh3aHnCZ/GeTdiab+5HJ8i+1VpaVUgobrJ5C9Mr8eYcZgAvgHNgKVAXugBGYTqFKrXXGeQZcAm+BF2wDacb5DeyBH8DtEmlYXC+Bd8AVsKM9SVtoBL4AH4BPwHfgz/zl0J+eC9qTcwW8B95wxFt7E/Ct//0VuCmlHH5qM8I57We1o+G8BM7YRn/7dcfx1XJoBlq+oAcaztrfP3Nn3D/7vXNv5Sn57wIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpAUIClAUoCkAEkBkgIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpAUIClAUoCkAEkBkgIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpA0A1XaXN7Yrw/Odq60J88+r+At1yh/As9py5xrX8KrwC3tzHuawd3yhqHWWkspY7/hI/Cqf/ea9Y9NTjScz7Sz74HxoanSibZjet3//0Vb5lz7XOnywbimGUzLG07XgLc0eKtDt7AAgk1OJj85lQwnQIcPNza6/djYNjwClI79A/7Gf1JmIOGZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Excel_svg__h",
    width: 68,
    height: 79,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAACXBIWXMAAC4jAAAuIwF4pT92AAABY0lEQVR4Xu3cvW3bYAAG4aNggEuo8xLp0nmhdB7AnQdy5zITuIo6DSFWXwqK/jkkQWrxHoCFBEoAD59UvtMYg3y4+/ximqYZOALzn2+/SQtwHmMsANN2Qq4xvgGPrFH24gw8AT/HGAtjDK5R7oEX4AKMHV0X4BX4DsxbjBl4AH79xxfc4nVhPQz3B1ZH4Af7+ql89v7fefAbf/3IThzIFwWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgsgWZGHd81r+ce8t+3j+ZrsYrM/9AMx3AGOMZZqmE/DGai+LVdvJeANOY4zF039H1sW7vWyanYFn4MR1D/E9yGZnA5FfhiEBfgO20QT8sY3jjAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Excel_svg__i",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVRoQ+2b61LbMBBGj3IhoUAphbbT93+6Ti8DoZCEXNwfq43WshyHUizi+pvZ8SWO2ONd2WH82RVFwf+kUdMBKTnnXNMxr63iLyvl9n3PgFnA7LBGhV0echJqgT2sAwZ+add3hyW++tqykBpbu70PPAnsnBsgcANgGIU9AbmANTaJ2ALbOujKHDawI2AMnJgY+dBjoF1ohdgicGtgBTyZWAE455LQJWDfxgo7AabAO+AMOPX7TqhWui3ZFl4jgHPg0YTz+5PQO+Bozo4RwAvg0sd7BH7qPx/S3ny2SWt1Vwjsb2AG3CI56fE2dopbWqt7gsBdAp+AG+Cj3z6lXOU2pQBrYAk8AHfATwJLaT4755ytsgXWCg+R1j0DPiDAX4HPwBVwTpjPOVpa23kJ3AO/kHwx+5dIW6/jAVIVHiJAp0gbXwNfEOhrpM0nhJbOAbwBFkgrT/1nWvF7v9QO1FsWUAXWCo+Rgc4Q6CukrW/ID6wtvSBUdoG09jlSqNQ1BvDA5oKlFy2tsl6lz31c8DaAN0h+IJW9INxJdLol80v9lrbQ9l48iSI3MMg8nRJyGpOAtReuVEvr0oLbGJn1NmFVOh9tLiOzrj+KkrnVVTgVdiAbOVSXlwVN5nfofTT+Yi5QVV1RiNYragLODfbP1QR8bGosUNeAG9UDd109cNfVA3ddPXDX1QN3XT1w19UDd109cNfVA3ddPXDX1QMfuWrdO6om4MYBjk1NwKoYPPeJiD0c1stR8XVY1VkP4wHsvvgPtK04hy3hKb992p/MMQauGyxlAIP2nyBqXprD2ix13Z6AilIVtoOq8UvNX0vCk/ccz4dtbgsTamRZEcB3Fa64eIqiKLyPVKuqsEs/4IMPNZA8kRdYPR4zH2pkmRPcOyVola2wbeMVAvvoB7tF/BMgf0h9WjmAYxfPD8S6dIeY1OZI/gpcUmoOq8tNYa0Pao6YR9QlA+1CK3Ds0/qGmNNmSN5PhPm8t8J69rS6d5TdMrcE66G1F7Ql29KxE+87kp8FPqjCatp8RAbAb88QC9OE4KhVvTa4TXyf1zKucMU7vQP2F664pUFOgFZbYXNYlqB8nalz0y6Q/JO3ppJB3BjU1I1nPVq6bWFzAEOzX3pDjUm84oiPbMSxL2tAmLttw6oKE6kfRHsd8XWvAMR2oEG0jVm2rcIsbYvvtp/9zsPuw+pbLbkg62ThX/ZWS53ewjtLcBhcSs8GPnYd+v9wZ/QHTbqvfA0XAmsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Excel_svg__j",
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVRoQ+3ZsQkCMRyF8S8iZAm765zAzr0cwJ3sLG8BN8gQSfW3CIdeZ/VM4P0gTSDwcXDVSxFBSikDJyAzpgaUiGjbRaLHXoAbPX5EBbgD63f8AjyACsSgpwJP4ArkiADgDLx+ePzvU+kfeIkIDsxj9x/OFL7jcDWHqzlczeFqDldzuJrD1Ryu5nA1h6s5XM3hag5Xc7iaw9UcruZwNYcLNPre2aCH7y4G1YCVPtIWgCOf1RYmWpbTtFv+Ni/P5g1xTodLg4W2uAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Excel_svg__f",
    x1: 4.498,
    y1: 6.636,
    x2: 10.616,
    y2: 17.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Excel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgExcel;